import { Log, Tracker } from '../Tracker';
import { convertToPageviewLog } from '../utils/pageviewHelper';
import { UBLSender } from './types';

export function getWebLogCondition(category: Log['category']) {
  if (category === 'tti') {
    return 'WEB_SEND';
  }
  if (category === 'click') {
    return 'WEB_SEND';
  }
  if (category === 'pageview') {
    return 'WEB_PAGEVIEW';
  }
  return 'WEB_ADD';
}

export function createWebSender(tracker: Tracker): UBLSender {
  const sender = (log: Log) => {
    const condition = getWebLogCondition(log.category);

    switch (condition) {
      case 'WEB_ADD':
        return tracker.addLog(log);
      case 'WEB_SEND':
        return tracker.sendImmediately(log);
      case 'WEB_PAGEVIEW':
        return tracker.addLog(convertToPageviewLog(log));
    }
  };
  return Object.assign(sender, tracker) as UBLSender;
}
